import createRequest from "@/utils/request"

/**
 * 添加新渠道
 */
const createChannel = (payload: any) => createRequest("SDL_URL").post("/channel/create", payload)

/**
 * 渠道详情
 */
const getChannelDetail = (payload: any) =>
    createRequest("SDL_URL").get("/channel/detail", {
        params: payload
    })

/**
 * 渠道列表
 */
const getChannelList = (payload: any) =>
    createRequest("SDL_URL").get("/channel/list", {
        params: payload
    })

/**
 * 编辑渠道
 */
const updateChannel = (payload: any) => createRequest("SDL_URL").post("/channel/update", payload)
/**
 * 添加cdn
 */
const createCdn = (payload: any) => createRequest("SDL_URL").post("/cdn/create", payload)

/**
 * cdn列表
 */
const getCdnList = (payload: any) =>
    createRequest("SDL_URL").get("/cdn/list", {
        params: payload
    })

/**
 * 编辑cdn
 */
const editCdn = (payload: any) => createRequest("SDL_URL").post("/cdn/edit", payload)

export default {
    createChannel,
    getChannelDetail,
    getChannelList,
    updateChannel,
    createCdn,
    getCdnList,
    editCdn
}
